import { Link, useLocation, useNavigate } from "react-router-dom";
import { CONTACT, NAV } from "../data/content";
import { scrollToId } from "../lib/scroll";

const LEGAL = [
  { to: "/impressum", label: "Impressum" },
  { to: "/datenschutz", label: "Datenschutzerklärung" },
  { to: "/agb", label: "AGB" },
  { to: "/widerruf", label: "Widerrufsbelehrung" },
  { to: "/cookies", label: "Cookie-Richtlinie" },
];

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const go = (id) => (location.pathname !== "/" ? navigate("/", { state: { scrollTo: id } }) : scrollToId(id));

  return (
    <footer className="relative border-t border-[var(--line)] bg-[var(--bg-2)]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/images/logo.png" alt="Salgin Solutions – Professionelle KI-Bilder & Skizzen" className="h-28 w-auto -ml-4" data-testid="footer-logo" />
          <p className="mt-4 text-sm text-[var(--muted)] max-w-sm leading-relaxed">
            Professionelle KI-Visualisierungen für Amazon, eBay, Onlineshops & Social Media. Mehr Aufmerksamkeit. Mehr Vertrauen. Mehr Verkäufe.
          </p>
          <p className="mt-6 font-mono text-[0.65rem] tracking-[0.2em] uppercase text-[var(--muted-2)]">{CONTACT.taxNote}</p>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow mb-6">Navigation</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>{n.to
                ? <Link to={n.to} className="text-sm text-[var(--muted)] hover:text-[var(--gold)] transition-colors" data-testid={`footer-nav-${n.id}`}>{n.label}</Link>
                : <button onClick={() => go(n.id)} className="text-sm text-[var(--muted)] hover:text-[var(--gold)] transition-colors" data-testid={`footer-nav-${n.id}`}>{n.label}</button>}
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow mb-6">Rechtliches</p>
          <ul className="space-y-3">
            {LEGAL.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-sm text-[var(--muted)] hover:text-[var(--gold)] transition-colors" data-testid={`footer-legal-${l.to.slice(1)}`}>{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow mb-6">Kontakt</p>
          <address className="not-italic text-sm text-[var(--muted)] space-y-2 leading-relaxed">
            <p className="text-[var(--text)]">{CONTACT.company}</p>
            <p>{CONTACT.owner}</p>
            <p>{CONTACT.street}<br />{CONTACT.city}</p>
            <p><a href={`mailto:${CONTACT.email}`} className="hover:text-[var(--gold)] transition-colors" data-testid="footer-email">{CONTACT.email}</a></p>
            <p><a href={CONTACT.phoneHref} className="hover:text-[var(--gold)] transition-colors" data-testid="footer-phone">{CONTACT.phone}</a></p>
            <p><a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="text-[var(--gold)] hover:text-[var(--gold-3)] transition-colors" data-testid="footer-whatsapp">Per WhatsApp schreiben</a></p>
          </address>
        </div>
      </div>
      <div className="border-t border-[var(--line)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 font-mono text-[0.6rem] tracking-[0.2em] uppercase text-[var(--muted-2)]">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} Salgin Solutions · Bad Oeynhausen</span>
          <span>Professionelle KI-Bilder & Skizzen</span>
        </div>
      </div>
    </footer>
  );
};
